export const jobAgentSlug: Record<string, string> = {
	da: 'jobagent',
	en: 'jobagent',
	'kl-gl': 'jobagenti',
};
